import privateAxiosInstance from "../utils/axios/private";
import { hybridDecrypt } from "../utils/crypto";

export const interviewApi = {
    /**
     * Verify Email (GET)
     * @param {string} interviewId
     * @param {string} recruiterId
     */
    async emailVerification(interviewId, recruiterId) {
        try {
            const response = await privateAxiosInstance.get(`/interview/emailvarification/${interviewId}/${recruiterId}`);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    /**
     * Verify OTP (POST)
     * @param {object} payload - { interview_id, otp }
     */
    async verifyOtp(payload) {
        try {
            const response = await privateAxiosInstance.post("/interview/otp/verify/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    /**
     * Validate Interview (POST)
     * @param {object} payload - { interview_id, candidate_id, ... }
     */
    async validate(payload) {
        try {
            const response = await privateAxiosInstance.post("/interview/validate/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    /**
     * Start Interview (POST)
     */
    async start() {
        try {
            const response = await privateAxiosInstance.post("/interview/start/");
            if (response.data.encrypted) {
                // console.log(await hybridDecrypt(response.data))
                return await hybridDecrypt(response.data);
            }
            // console.log(response.data.data["s3_id"])
            return response.data;
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    /**
     * Process Interview (POST)
     * @param {object} payload - { interview_id, question_id, answer, ... }
     */
    async process(payload) {
        try {
            const response = await privateAxiosInstance.post("/interview/process/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    /**
     * End Interview (POST)
     * @param {object} payload - { interview_id, status }
     */
    async end(payload) {
        try {
            const response = await privateAxiosInstance.post("/interview/end/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    /**
     * Get Interview Report (GET)
     * @param {object} params - optional query params { interview_id }
     */
    async getReport(params = {}) {
        try {
            const response = await privateAxiosInstance.get("/interview/report/", { params });
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async getFilteredReport(payload) {
        try {
            const response = await privateAxiosInstance.post("/interview/report/filter/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    /**
     * Resume Interview (POST)
     * @param {object} payload - { interview_id, candidate_id }
     */
    async resume() {
        try {
            const response = await privateAxiosInstance.post("/interview/resume/");
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    /**
     * Heartbeat (POST)
     * @param {object} payload - { interview_id, candidate_id, timestamp }
     */
    async heartbeat(payload) {
        try {
            const response = await privateAxiosInstance.post("/interview/heartbeat/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    /**
     * Mark Interview as Inactive (POST)
     * @param {object} payload - { interview_id, reason }
     */
    async inactive(payload) {
        try {
            const response = await privateAxiosInstance.post("/interview/inactive/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async terminate(payload) {
        try {
            const response = await privateAxiosInstance.post("/interview/violation/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async jdWiseInterviewReport({ page = 1, page_size = 5 }) {
        try {
            const response = await privateAxiosInstance.get("/interview/", { params: { page, page_size }, });
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async jdWiseInterviewReportFilter(payload, page = 1, page_size = 5) {
        try {
            // console.log(payload)
            // const encryptedPayload = await hybridEncrypt(payload)
            const response = await privateAxiosInstance.post("/interview/filter/", payload, { params: { page, page_size }, });
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async downloadReport(params = {}) {
        try {
            const response = await privateAxiosInstance.get("/interview/export/", { params, responseType: "blob" });
            // if (response.data.encrypted) {
            //     return await hybridDecrypt(response.data);
            // }
            return {
                status: response.status,
                data: response.data, // Blob
            };
        }
        catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    message:
                        "Network error. Please check your internet connection.",
                };
            }

            return {
                status: error.response?.status || 500,
                message:
                    error.response?.data?.message ||
                    "Failed to download report.",
            };
        }
    },

    async getVideoPresignedUrl(params = {}) {
        try {
            const response = await privateAxiosInstance.get("/interview/video/", { params });
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async interviewVideoUpload(payload) {
        try {
            // const encryptedPayload = await hybridEncrypt(payload);
            const response = await privateAxiosInstance.post("interview/upload/chunks/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },
};

